import { createRoot } from 'react-dom/client'
import { useState, useEffect } from 'react'
import apiFetch from '@wordpress/api-fetch'

const rootElement = document.getElementById('rjo-university-root')
const universityId = rootElement.getAttribute('data-university-id')
const root = createRoot(rootElement)
root.render(<UniversityListing universityId={universityId} />)

function UniversityListing(props) {

    const filters = [
        {name: 'Futures Trading', slug: 'futures-trading'},
        {name: 'Options Trading', slug: 'options-trading'},
        {name: 'Spread Trading', slug: 'spread-trading'},
        {name: 'Technical Analysis', slug: 'technical-analysis'},
        {name: 'Fundamental Analysis', slug: 'fundamental-analysis'},
        {name: 'General Trading', slug: 'general-trading'},
        {name: 'Managed Futures', slug: 'managed-futures'}
    ]

    const [loading, setLoading] = useState(false)
    const [filterIndex, setFilterIndex] = useState(0)
    const [articles, setArticles] = useState([])
    const [maxPage, setMaxPage] = useState()
    const [currentPage, setCurrentPage] = useState(1)

    useEffect(() => {
        setLoading(true)
        const filterSlug = filters[filterIndex].slug
        apiFetch({path: `/rjof/v1/university/?&page=${currentPage}&category=${filterSlug}`})
            .then( res => {
                setMaxPage(res.count)
                setArticles(articles.concat(res.posts))
                setLoading(false)
            })
    }, [filterIndex, currentPage])

    function setNewFilter(evt) {
        setArticles([])
        setMaxPage(null)
        setCurrentPage(1)
        setFilterIndex(evt.target.selectedIndex)
    }

    return (<>
    <h2 className="university-label">{filters[filterIndex].name} Courses</h2>
        <select onChange={setNewFilter} className="university-filter">
            {
                filters.map((thisFilter, idx) => (
                    <option value={thisFilter.slug} selected={idx === filterIndex}>{thisFilter.name}</option>
                ))
            }
        </select>
        <section className="university-grid">
            {articles.map(art => (
                <a href={art.link}>
                    <article className="university-article add-shadow-only">
                        { art.thumbnail ?
                            <img src={art.thumbnail} />
                            :
                            <span className="img-placeholder" />
                        }
                        <span class="category-pill">{art.category}</span>
                        <h4 className="university-title" dangerouslySetInnerHTML={{__html: art.title}}></h4>
                        <p>{art.excerpt}</p>
                    </article>
                </a>
            ))}
            { !loading && articles.length === 0 &&
                <span>No {filters[filterIndex].name} courses found</span>
            }
        </section>
        {
            loading && 
            <h3>LOADING...</h3>
        }
        {currentPage < maxPage &&
            <div className="more-control">
                <button onClick={() => setCurrentPage(currentPage + 1)}>View More</button>
            </div>
        }
    </>
    )
}